import { createAction, handleActions } from 'redux-actions';

const setSupplier = createAction("MODALS/SUPPLIER/SET_SUPPLIER");

const defaultState = null;

const reducer = handleActions(
  {
    [setSupplier]: (state, action) => action.payload
  },
  defaultState
);

export { setSupplier, reducer };
